import { useCallback, useEffect, useState } from 'react'
import { useStytch } from '@stytch/react'
import { ADMIN_EVENT_NAMES, tracking } from '@/lib/segment/tracking'
import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'
import { postAuthOauthLogin } from '@/api/generated/auth/auth'

// @ts-expect-error TS2525 -- MIGRATION: not approved, fix when encountered
export function useStytchOAuth({ onSuccess, onFailure } = {}) {
  const stytch = useStytch()
  const onSuccessRef = useAutoUpdatingRef(onSuccess)
  const onFailureRef = useAutoUpdatingRef(onFailure)
  // Seed from the URL so the login form doesn't flash before the verification
  // effect runs when we return from the Google redirect with a token.
  const [isVerifying, setIsVerifying] = useState(() =>
    Boolean(new URLSearchParams(window.location.search).get('token')),
  )

  const startGoogleOAuth = useCallback(() => {
    stytch.oauth.google.start({
      login_redirect_url: window.location.origin,
    })
  }, [stytch])

  // After the Stytch Google redirect we receive a one-time OAuth token in the URL.
  // Instead of exchanging it for a Stytch session client-side, hand it to our own
  // backend (/auth/oauth/login), which verifies it with Stytch, confirms a matching
  // admin exists, and returns our AccessToken.
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token')
    if (!token) return

    setIsVerifying(true)
    postAuthOauthLogin({ Token: token })
      .then((response) => {
        tracking.trackEvent(ADMIN_EVENT_NAMES.GOOGLE_OAUTH_LOGIN)
        onSuccessRef.current?.(response)
      })
      .catch((err) => {
        // Keep the loading state on success — the caller navigates away. On
        // failure, clear it so the login form returns.
        setIsVerifying(false)
        onFailureRef.current?.(err)
      })
  }, [onSuccessRef, onFailureRef])

  return { startGoogleOAuth, isVerifying }
}
